var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurnitureMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_9389_79067)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6111 21.0969C13.2236 21.0969 12.852 21.2508 12.578 21.5248C12.304 21.7988 12.1501 22.1704 12.1501 22.5579V26.7798C12.1501 27.1673 12.304 27.5389 12.578 27.8129C12.852 28.0869 13.2236 28.2408 13.6111 28.2408H28.388C28.7755 28.2408 29.1471 28.0869 29.4211 27.8129C29.695 27.5389 29.849 27.1673 29.849 26.7798V22.5579C29.849 22.1704 29.695 21.7988 29.4211 21.5248C29.1471 21.2508 28.7755 21.0969 28.388 21.0969C28.0005 21.0969 27.6289 21.2508 27.3549 21.5248C27.0809 21.7988 26.927 22.1704 26.927 22.5579V24.6688C26.927 25.0278 26.636 25.3188 26.277 25.3188H15.7221C15.3631 25.3188 15.0721 25.0278 15.0721 24.6688V22.5579C15.0721 22.1704 14.9181 21.7988 14.6442 21.5248C14.3702 21.2508 13.9986 21.0969 13.6111 21.0969ZM13.6111 19.7969C14.3433 19.7969 15.0456 20.0878 15.5634 20.6055C16.0812 21.1233 16.3721 21.8256 16.3721 22.5579V24.0188H25.627V22.5579C25.627 21.8256 25.9179 21.1233 26.4357 20.6055C26.9535 20.0878 27.6557 19.7969 28.388 19.7969C29.1202 19.7969 29.8225 20.0878 30.3403 20.6055C30.8581 21.1233 31.149 21.8256 31.149 22.5579V26.7798C31.149 27.5121 30.8581 28.2144 30.3403 28.7321C29.8225 29.2499 29.1202 29.5408 28.388 29.5408H13.6111C12.8788 29.5408 12.1766 29.2499 11.6588 28.7321C11.141 28.2144 10.8501 27.5121 10.8501 26.7798V22.5579C10.8501 21.8256 11.141 21.1233 11.6588 20.6055C12.1766 20.0878 12.8788 19.7969 13.6111 19.7969Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7774 12.6496C16.11 12.6496 15.4699 12.9147 14.998 13.3867C14.5261 13.8586 14.2609 14.4987 14.2609 15.1661V20.4436C14.2609 20.8025 13.9699 21.0936 13.6109 21.0936C13.252 21.0936 12.9609 20.8025 12.9609 20.4436V15.1661C12.9609 14.1539 13.363 13.1832 14.0788 12.4674C14.7945 11.7517 15.7652 11.3496 16.7774 11.3496H25.2214C26.2336 11.3496 27.2043 11.7517 27.92 12.4674C28.6357 13.1832 29.0378 14.1539 29.0378 15.1661V20.4436C29.0378 20.8025 28.7468 21.0936 28.3878 21.0936C28.0289 21.0936 27.7378 20.8025 27.7378 20.4436V15.1661C27.7378 14.4987 27.4727 13.8586 27.0008 13.3867C26.5288 12.9147 25.8888 12.6496 25.2214 12.6496H16.7774Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 28.2383C15.0258 28.2383 15.3168 28.5293 15.3168 28.8883V30.9993C15.3168 31.3583 15.0258 31.6493 14.6668 31.6493C14.3079 31.6493 14.0168 31.3583 14.0168 30.9993V28.8883C14.0168 28.5293 14.3079 28.2383 14.6668 28.2383Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3326 28.2383C27.6916 28.2383 27.9826 28.5293 27.9826 28.8883V30.9993C27.9826 31.3583 27.6916 31.6493 27.3326 31.6493C26.9736 31.6493 26.6826 31.3583 26.6826 30.9993V28.8883C26.6826 28.5293 26.9736 28.2383 27.3326 28.2383Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_9389_79067",
    x: -17.662,
    y: -17.662,
    width: 77.324,
    height: 77.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79067"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79067",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureMobile);
export default __webpack_public_path__ + "static/media/furnitureMobile.370e8be9ef656b04750fd9c43c4335d0.svg";
export { ForwardRef as ReactComponent };